// Auth service (login, register, verification) runs on port 3001
export const AUTH_BASE_URL = process.env.REACT_APP_AUTH_URL || 'https://api.liberianpost.com';

// Inventory service runs on port 3017
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.liberianpost.com';

export const API_ENDPOINTS = {
  // Auth (on AUTH_BASE_URL)
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  VERIFY: '/auth/verify',

  // Inventory (on API_BASE_URL)
  PRODUCTS: '/api/inventory/products',
  PRODUCT_BY_ID: (id) => `/api/inventory/products/${id}`,
  PRODUCT_BY_BARCODE: (barcode) => `/api/inventory/products/barcode/${barcode}`,

  STOCK_LEVELS: '/api/inventory/stock/levels',
  STOCK_MOVEMENTS: '/api/inventory/stock/movements',
  STOCK_IN: '/api/inventory/stock/in',
  STOCK_ADJUST: '/api/inventory/stock/adjust',
  STOCK_RECEIPTS: '/api/inventory/stock/receipts',

  SALES: '/api/inventory/pos/sale',

  DASHBOARD: '/api/inventory/dashboard',
  TAX_REPORT: '/api/inventory/reports/tax',
  VALUATION: '/api/inventory/reports/valuation',

  // ---- Tax (Wave 1) ----
  TAX_SUMMARY: '/api/inventory/tax/summary',
  TAX_FILINGS: '/api/inventory/tax/filings',
  TAX_FILING_BY_ID: (id) => `/api/inventory/tax/filings/${id}`,
  TAX_FILING_SUBMIT: (id) => `/api/inventory/tax/filings/${id}/submit`,
  TAX_CLEARANCE: '/api/inventory/tax/clearance',

  // ---- LRA (Wave 2) ----
  LRA_ME: '/api/lra/me',
  LRA_INTELLIGENCE: '/api/lra/intelligence',
  LRA_BUSINESSES: '/api/lra/businesses',
  LRA_BUSINESS_BY_DSSN: (dssn) => `/api/lra/businesses/${dssn}`,
  LRA_AUDIT_SIGNALS: '/api/lra/audit-signals',
  LRA_AUDIT_SIGNAL_DETECT: '/api/lra/audit-signals/detect',
  LRA_AUDIT_SIGNAL_BY_ID: (id) => `/api/lra/audit-signals/${id}`,
  LRA_REVENUE_TREND: '/api/lra/revenue-trend',
  LRA_REGISTRATION_TREND: '/api/lra/registration-trend',
  LRA_DIVISIONS: '/api/lra/divisions',
  LRA_RECENT_ACTIVITY: '/api/lra/recent-activity',
  LRA_REPORTS_SUMMARY: '/api/lra/reports/summary',
  LRA_REPORTS_TOP_TAXPAYERS: '/api/lra/reports/top-taxpayers',
    // ---- LRA Registration (Wave 3) ----
  LRA_REG_PREVIEW: '/api/lra/registration/preview',
  LRA_REG_REGISTER: '/api/lra/registration/register',
  LRA_REG_HISTORY: '/api/lra/registration/history',
  LRA_REG_BY_ID: (id) => `/api/lra/registration/${id}`,
  LRA_REG_REFERENCE: '/api/lra/registration/utils/reference',
    // ---- LRA Registration (Wave 3) ----
  LRA_REG_PREVIEW: '/api/lra/registration/preview',
  LRA_REG_REGISTER: '/api/lra/registration/register',
  LRA_REG_UPLOAD: '/api/lra/registration/upload',
  LRA_REG_HISTORY: '/api/lra/registration/history',
  LRA_REG_BY_ID: (id) => `/api/lra/registration/${id}`,
  LRA_REG_REFERENCE: '/api/lra/registration/utils/reference',
};
